import "../FooterCom/Footer.css";
import { FaAngleRight, FaFacebookF } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { FaPinterest } from "react-icons/fa6";
import { FaYoutube } from "react-icons/fa";
import logo from "../../Images/weddingz adda logo (1).png";
import { NavLink } from "react-router-dom";

const Footer = () => {
  const quickLink = [
    { name: "About Us", url: "/about-us" },
    { name: "Blogs", url: "/blogs" },
    { name: "FAQ", url: "/faq" },
    { name: "Get Support", url: "/get-support" },
    { name: "Privacy Policy", url: "/privacy-policy" },
    { name: "Terms Condition", url: "/terms-&-condition" },
  ];

  return (
    <section className="main-footer-section">
      <div className="container">
        <div className="footer-logo">
          <img src={logo} />
        </div>
        <div className="footer-section-details-main-con">
          <h2>
            Weddingz Adda - <span>Your Personal Wedding Planner</span>
          </h2>
          <p>Plan your wedding with Us</p>
          <p>
            Get best quote from Kanha Banquet & Lawn and book your date! Send
            enquiry to your selected list of Wedding Venues at Wedding Adda and
            choose the best. Browse for more Wedding Venues in your city and
            more wedding vendors in your city at Wedding Adda and plan your
            wedding hassle free.
          </p>
        </div>

        <div className="footer-mid-main-con">
          <div className="row">
            <div className="col-lg-4 col-md-4">
              <div className="footer-mid-main-addres-main-con">
                <div className="footer-mid-main-addres">
                  <h3>Registered Address</h3>
                  <p>
                    Number 102/B, Office, MOHID HEIGHTS सुरेश नगर, अंधेरी पश्चिम
                    1st, Mumbai, Maharashtra 400053
                  </p>
                </div>
                <div className="footer-mid-main-contact-details">
                  <div className="footer-mid-main-contact-info-main-con">
                    <h4>For Vendors</h4>
                    <br />
                    <NavLink to="mailto:weddingzadda@gmail.com">
                      weddingzadda@gmail.com
                    </NavLink>
                    <br />
                    <NavLink to="tel:+919321126614">+91 93211 26614</NavLink>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-2 col-md-3">
              <div className="footer-main-social-media-mink-main-com">
                <h3>Follow us on:</h3>
                <div className="footer-main-social-media-con">
                  <FaFacebookF />
                  <NavLink
                    to="https://www.instagram.com/weddingz.adda/?fbclid=IwY2xjawLDgWhleHRuA2FlbQIxMQBicmlkETFWdlp2NERZcTVncFA1MlBlAR7gIDmwzX9SzKYyy2guaLwPYn5MMmmDHZDxdCOjKD09nm6Muzf25Y5NmulE3Q_aem_FtNjceeM1B8BiOjT2O4yUw"
                    target="_blank"
                    style={{ color: "#cdcdcd" }}
                  >
                    Facebook
                  </NavLink>
                </div>
                <div className="footer-main-social-media-con">
                  <FaInstagram />
                  <NavLink
                    to="https://www.facebook.com/profile.php?id=61572781536827#"
                    target="_blank"
                    style={{ color: "#cdcdcd" }}
                  >
                    Instagram
                  </NavLink>
                </div>
              </div>
            </div>
            <div className="col-lg-2 col-md-3">
              <div className="footer-main-social-media-mink-main-com">
                <h3>Quick Links</h3>
                {quickLink.map((link, index) => (
                  <div className="footer-main-social-media-con" key={index}>
                    <FaAngleRight />
                    <NavLink style={{ color: "#cdcdcd" }} to={link.url}>
                      {link.name}
                    </NavLink>
                  </div>
                ))}
              </div>
            </div>

            <div className="col-lg-4 col-md-4">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3769.391046565422!2d72.8265301!3d19.1343526!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c946e4282bd9%3A0x2781c048e4376933!2sShree%20Krishna%20Digital%20Marketing%20Services%20%7C%20Best%20Digital%20Marketing%20Company%20in%20Andheri%20%7C%20Digital%20Marketing%20Agency%20in%20Andheri!5e0!3m2!1sen!2sin!4v1750508070147!5m2!1sen!2sin"
                width={"100%"}
                height={250}
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>

            {/* <div className="col-lg-5 col-md-4">
              <div className="Footer-section-app-download">
                <h3>
                  Get The <span>Weddingz Adda</span> App
                </h3>
                <div className="footer-section-app-download-app-store-main-con">
                  <div className="footer-section-app-download-app-store-con">
                    <div className="footer-section-app-download-app-store">
                      <img src={playstoreapp} alt="play store app" />
                    </div>
                    <div className="footer-section-app-download-app-store">
                      <img src={appstore} alt="app store" />
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Footer;
